<template>
  <svg width="100" viewBox="0 0 100 100">
    <use xlink:href="#snap"></use>
  </svg>
</template>
